export const SUCCESS_GET_FILES = 'SUCCESS_GET_FILES';
export const FAILED_GET_FILES = 'FAILED_GET_FILES';
export const RESET_GET_FILES = 'RESET_GET_FILES';


// WEBPACK FOOTER //
// ./src/state/constants/fileConstants.js